<template>
  <div>
    <section class="row bar bg-gray   padding-big text-md-center">
    <!-- footer start here --> 
    <div class="footer-agile jarallax">
      <div class="container" style="width: 100% !important">
        <div class="footer-btm-agileinfo">
          <div class="col-md-3  footer-grid">
            <h3>关于太药</h3>
            <ul>
              <li><a href="index.html">集团简介</a></li>
              <li><a href="http://www.sxtaiyao.com/old/tyhtml/prolist.html" target="_blank">太原药业</a></li> 

              <!-- <li><a href="#">发展大事记</a></li> 
              <li><a href="contact.html">企业文化</a></li> 
              <li><a href="contact.html">集团主要成员</a></li> 
              <li><a href="contact.html">社会责任</a></li>  -->
            </ul>
          </div> 
          <div class="col-md-3  footer-grid">
            <h3>产品中心</h3>
            <ul>
              <li><a href="index.html">明星产品</a></li>
              <li><a href="#">抗肿瘤药品</a></li> 
            </ul>
          </div> 
          <div class="col-md-3 footer-grid">
            <h3>新闻中心</h3>
            <ul>
              <li><a href="index.html">公司新闻</a></li>
              <li><a href="#">公告通知</a></li> 
            </ul>
          </div> 
          <div class="col-md-3  footer-grid w3social">
            <h3>科技研发</h3>
            <ul>
              <li><a href="index.html">科技研发</a></li>
            </ul> 
          </div> 
          <div class="col-md-3  footer-grid w3social">
            <h3>联系我们</h3>
            <ul>
              <li><a href="index.html">联系电话：0351-6074034</a></li>
              <li><a href="#">电子邮箱：shanxliye@sxlyzy.club</a></li> 
              <li><a href="#">地址：山西省太原市晋源区化工路21号</a></li> 
              <!-- <li><a href="contact.html">企业文化</a></li> 
              <li><a href="contact.html">集团主要成员</a></li> 
              <li><a href="contact.html">社会责任</a></li>  -->
            </ul> 
          </div> 
          <div class="col-md-12 col-xs-12 footer-grid footer-review">
            <div class="copy-w3lsright"> 
              <!-- <p>Copyright &copy;  <a target="_blank" href="http://sc.chinaz.com/moban/"></a></p> -->
            </div> 
          </div> 
          <div class="clearfix" />
        </div>
        <div class="footer-top-agileinfo">  
          <div class="social-wthree-icons bnragile-icons">
            <ul>
              <li>
                <a
                  href="#"
                  class="fa fa-facebook icon icon-border facebook"
                />
              </li>
              <li>
                <a
                  href="#"
                  class="fa fa-twitter icon icon-border twitter"
                />
              </li>
              <li>
                <a
                  href="#"
                  class="fa fa-google-plus icon icon-border googleplus"
                />
              </li>
              <li>
                <a
                  href="#"
                  class="fa fa-dribbble icon icon-border dribbble"
                />
              </li> 
            </ul>
            <div class="clearfix" />
          </div>  
        </div>			
      </div>
      <div class="wrap">
        <div class="cls"></div>
        <section class="footerBotton">
          <p class="copyright"><a href="https://beian.miit.gov.cn/">晋ICP备2021007499号</a>&nbsp;&nbsp;&nbsp;&nbsp;<img style="width:18px;height:18px;" original="images/备案图标.png" src="images/备案图标.png"/><a href="https://beian.mps.gov.cn/#/query/webSearch?code=14011002011308" rel="noreferrer" target="_blank">晋公网安备14011002011308</a></p>
          <p class="copyright about_index_img">Copyright &copy; 太原药业 All Rights Reserved <span class="none_720"></span></p>
          <div class="cls"></div>
        </section>
      </div>
    </div> 
    <!-- //footer end here -->   
     </section>

  </div>
</template>
<style scoped>
.footer-grid { width: 20% !important;}
</style>
